
export class BdtCatalogoEquipModel {
    id: number;
    idEquipamiento: number;
    idProyecto: number;
    unidades: number;
    icono: string;

    // Campos agregados para pasar en la llamada a la BDT
    borrar: boolean;
    ultimo: boolean;
    urlApiSSO: string;
    urlApiNP: string;
    urlApiEcoSAT: string;
    urlApiIA: string;
    urlWeb: string;

    constructor() { }
}